import React from "react"
import { getWordDeclension } from "src/utils/helpers"

// count — для страниц с серверной пагинацией: там items это одна страница, а в заголовке нужно всего.
export function useUpdateHeaderTitle({ items, defaultTitle, arrType, count }) {
  const [headerTitle, setHeaderTitle] = React.useState(defaultTitle)

  function updateTitle(count) {
    setHeaderTitle(getWordDeclension(count, arrType))
  }

  React.useEffect(() => {
    updateTitle(count ?? items?.length ?? 0)
  }, [items, arrType, count])

  return headerTitle
}
